import { ChatThreadSelected, ChatThread } from '../types'

export function threadSelectedGenerate(thread: ChatThread): ChatThreadSelected {
  return {
    ...thread,
    loaded: false,
  }
}
